import React from 'react'
import Header from '../Component5/Header'
import Navbar from '../Component/Nvabar/Navbar'
import Footer from '../Component/Footer/Footer'
import Main from '../Component5/Main'
import Related from '../Component2/Related/Related';
import Description from '../Component5/Description'
const Page6 = () => {
  return (
    <>
    <Navbar/>
    <Header/>
    <Main/>
    <Description/>
    <Related/>
    <Footer/>
    </>
  )
}

export default Page6